/**
 * DevExtreme (esm/__internal/pagination/common/pagination_config_provider.js)
 * Version: 24.2.5
 * Build date: Fri Feb 14 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import {
    BaseInfernoComponent
} from "@devextreme/runtime/inferno";
import {
    PaginationConfigContext
} from "./pagination_config_context";
export const PaginationConfigProviderDefaultProps = {};
export class PaginationConfigProvider extends BaseInfernoComponent {
    constructor() {
        super(...arguments);
        this.state = {}
    }
    getConfig() {
        return {
            isGridCompatibilityMode: this.props.isGridCompatibilityMode
        }
    }
    getChildContext() {
        return _extends({}, this.context, {
            [PaginationConfigContext.id]: this.getConfig() || PaginationConfigContext.defaultValue
        })
    }
    render() {
        return this.props.children
    }
}
PaginationConfigProvider.defaultProps = PaginationConfigProviderDefaultProps;
